import { Dispatch } from "redux";
import { ActionType } from "./ActionTypes";
import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const submitTestimonial = (formData: FormData) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.SUBMIT_TESTIMONIAL_INIT });
      const url = `${BASE_URL}/testimonial/create`;
      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("Testimonial submitted successfully:", response.data);

      dispatch({
        type: ActionType.SUBMIT_TESTIMONIAL_SUCCESS,
        payload: response.data,
      });

      return true;
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        "Failed to submit testimonial. Please try again later.";

      console.error("Testimonial submission failed:", errorMessage);

      dispatch({
        type: ActionType.SUBMIT_TESTIMONIAL_FAIL,
        payload: errorMessage,
      });

      toast.error(errorMessage);
      return false;
    }
  };
};

